const folder = 'photography';

export const sizeIncrement = 256;

export default function(photo, w, addSignature) {
	const image = {
		baseURL: 'https://res.cloudinary.com/thinkloop',
		folder: 'photography',
		modifiers: 'c_fill,q_auto:best,f_auto,fl_advanced_resize,e_unsharp_mask,cs_srgb',
		width: 0,
		height: 0,
		version: null,
		signature: '',
		url: null
	};

	if (w) {
		image.width = calculateDimension(w, photo.dimensions.widthPx);
	}
	else {
		image.width = calculateDimension(sizeIncrement, photo.dimensions.widthPx);
	}
	image.height = Math.round(image.width / photo.dimensions.widthPx * photo.dimensions.heightPx);

	// signature
	if (addSignature || image.width > sizeIncrement * 2 || image.height > sizeIncrement * 2) {
		const ratioW = photo.dimensions.widthPx / 3800;
		const ratioH = photo.dimensions.heightPx / 3800;
		const ratio = (ratioW + ratioH) / 2;
		image.signature = `c_fit,e_shadow:30,l_${folder}:signature,o_50,g_south_east,x_${Math.round(100 * ratio)},y_${Math.round(60 * ratio)},w_${Math.round(450 * ratio)}`;
	}

	// url
	const url = [image.baseURL];
	if (image.signature) {
		url.push(image.signature);
	}
	url.push(`${image.modifiers},w_${image.width}`);
	if (photo.cloudinaryVersion) {
		url.push(photo.cloudinaryVersion);
	}
	url.push(image.folder);
	url.push(`${photo.filename}.jpg`);
	image.url = url.join('/');

	return image;
}

function calculateDimension(d, max) {
	let res;

	if (d >= max) {
		return max;
	}
	else if (d <= sizeIncrement / 2) {
		res = sizeIncrement / 2;
	}
	else {
		res = Math.ceil(d / sizeIncrement) * sizeIncrement;
	}

	// add 1.5X to the dimension to get sharper images, 1X was blurry
	res = res * 1.5;

	if (res >= max) {
		return max;
	}
	return Math.round(res);
}